import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Apollo} from 'apollo-angular';
import{map}from 'rxjs/operators'; 
import {global} from '../../../graphqlserver/conection';
import * as gqlUsuarios from '../graphql/gql_usuarios';
import * as gqlConfig from '../graphql/gql_configuracion';
import { Usuario } from '../models/usuarios';
import { Configmodel } from '../models/configuracion';
import CryptoES from 'crypto-es'; 

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  constructor(private apollo:Apollo, private http:HttpClient) { }

  listausuarios(ci:string){
    return this.apollo.watchQuery<any>({
      query: gqlUsuarios.gql_listausuarios,
      variables:{ci}
    }).valueChanges.pipe(map(result => result.data.lstUsuariosdet));
  }

  organigrama(){
    return this.apollo.watchQuery<any>({
      query: gqlUsuarios.gql_organigrama
    }).valueChanges.pipe(map(result => result.data.organigrama));
  }

  actualizausuarios(datos:Usuario){
    datos.clave=(CryptoES.AES.encrypt(datos.clave, global.secret)).toString();
    return this.apollo.mutate({
      mutation: gqlUsuarios.gql_actualizaUsuario,
      variables:{datos}
    })
  }

  changePassword(idcarnet: string, clave: string) {
    const encryptedPassword = CryptoES.AES.encrypt(clave, global.secret).toString();
    return this.http.put<any>(`${global.urlgraph}/changePassword`, {
      idcarnet,
      password: encryptedPassword
    });
  }

  cambiathema(ci:string,thema:string){
    return this.apollo.mutate({
      mutation: gqlUsuarios.gql_cambiaThema,
      variables:{ci,thema}
    })
  }

  sincUserBiotime(){
    return this.apollo.mutate({
      mutation: gqlUsuarios.gql_sincUserBiotime
    })
  }

}

